import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { Tables } from "@/integrations/supabase/types";

type FilterSelectorProps = {
  label: string;
  value: string;
  onChange: (value: string, affectedBranchingRules?: string[]) => void;
  filters?: Tables<"filters">[];
  disabled?: boolean;
  readOnly?: boolean;
  onFilterChange?: (filterId: string) => Promise<string[]>;
};

export const FilterSelector = ({
  label,
  value,
  onChange,
  filters,
  disabled,
  readOnly,
  onFilterChange,
}: FilterSelectorProps) => {
  if (readOnly || !filters || filters.length === 0) {
    return (
      <div className="space-y-2">
        <Label htmlFor={label}>{label}</Label>
        <div className="px-3 py-2 border rounded-md text-muted-foreground">No Filter</div>
      </div>
    );
  }

  const handleFilterChange = async (newValue: string) => {
    console.log("[FilterSelector] Filter changed to:", newValue);
    if (onFilterChange) {
      const affectedRules = await onFilterChange(newValue);
      onChange(newValue, affectedRules);
    } else {
      onChange(newValue);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={label}>{label}</Label>
      <Select value={value} onValueChange={handleFilterChange} disabled={disabled}>
        <SelectTrigger>
          <SelectValue placeholder={`Select ${label.toLowerCase()}`} />
        </SelectTrigger>
        <SelectContent>
          <ScrollArea className="h-[200px]" maxHeight="300px">
            <SelectItem value="none">No Filter</SelectItem>
            {filters?.map((filter) => (
              <SelectItem key={filter.id} value={filter.id}>
                {filter.name}
              </SelectItem>
            ))}
          </ScrollArea>
        </SelectContent>
      </Select>
    </div>
  );
};
